export default "<div [class.d-none]=\"!active\" class=\"pane\">\r\n\t<ng-content></ng-content>\r\n</div>\r\n"